import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  valorTotal: Yup.string().required(mensagemPadrao).nullable(),
  dataPrimeiroVencimento: Yup.string().required(mensagemPadrao),
  quantidadeParcelas: Yup.string().required(mensagemPadrao)
})
